



























































































































import {
  creditFunds,
  depositFunds,
  extractFunds,
} from '@/api/Agency/agency.api'
import { User } from '@/api/Auth/auth.interface'
import { getProducts, getTopUpAgentById } from '@/api/Topup/topup.api'
import { formatCurrency } from '@/utils/functions'
import { Params, VueForm } from '@/utils/interfaces'
import { GetProductDTO, TopUpAgent } from '@/utils/interfaces/topup.interface'
import { productsEnum } from '@/utils/productsCode.constant'
import { Services } from '@/utils/services.enum'
import { number } from '@/utils/validators'
import { AxiosResponse } from 'axios'
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import ActionButton from './ActionButton.vue'
import Autocomplete from './Autocomplete.vue'
import Dialog from './Dialog.vue'
export default Vue.extend({
  components: {
    ActionButton,
    appDialog: Dialog,
    Autocomplete,
  },
  props: {
    user: Object as PropType<User>,
  },
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
        number: (v: string) =>
          number(v) || this.$t('validation.must-be-a-number'),
      },
      cruds: {
        extract: {
          description: '',
          amount: '',
        },
        convert: {
          description: '',
          count: '',
          product_amount: '',
        },
        deposit: {
          description: '',
          amount: '',
        },
      },
      product: null as null | GetProductDTO,
      dialog: false,
      getProducts: (params?: Params) =>
        getProducts({ ...params, code: productsEnum.TOPUP }),
      tabs: 0,
      loading: false,
      agentData: {} as TopUpAgent,
    }
  },
  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.xs
    },
    currentPrice(): string | number {
      if (!this.product) {
        return '0'
      } else {
        const price = this.agentData.topup_prices.find(
          price =>
            price.product === (this.product as GetProductDTO).uuid &&
            price.currency === 'USD',
        )
        if (!price) {
          return 0
        } else {
          return price.cost || 0
        }
      }
    },
    displayedPrice(): string | TranslateResult {
      if (!Number(this.currentPrice)) {
        return this.$t('no_price')
      }
      return `${this.$t('product_cost')}: ${formatCurrency(this.currentPrice)}`
    },
    totalCost(): number {
      const cost = Number(this.currentPrice)
      const count = Number(this.cruds.convert.count)
      if (!cost || !count) return 0
      return cost * count
    },
    maxAmount(): number {
      return Math.floor(Number(this.user.fund) / Number(this.currentPrice))
    },
  },
  methods: {
    async onConvert() {
      let form: VueForm
      let response: AxiosResponse

      switch (this.tabs) {
        case 0:
          form = this.$refs.convert as VueForm
          if (!form.validate()) return
          this.loading = true
          try {
            response = await creditFunds({
              ...this.cruds.convert,
              agent: this.user.uuid,
            })
            this.user.fund = (
              Number(this.user.fund) - Number(response.data.consumed_fund)
            ).toFixed(2)
            form.reset()
            this.dialog = false
          } finally {
            this.loading = false
          }

          break

        case 1:
          form = this.$refs.extract as VueForm
          if (!form.validate()) return
          this.loading = true
          try {
            await extractFunds({
              ...this.cruds.extract,
              agent: this.user.uuid,
            })
            this.user.fund = (
              Number(this.user.fund) - Number(this.cruds.extract.amount)
            ).toFixed(2)
            form.reset()
            this.dialog = false
          } finally {
            this.loading = false
          }
          break

        case 2:
          form = this.$refs.deposit as VueForm
          if (!form.validate()) return

          this.loading = true
          try {
            await depositFunds({
              ...this.cruds.deposit,
              agent: this.user.uuid,
            })
            this.user.fund = (
              Number(this.user.fund) + Number(this.cruds.deposit.amount)
            ).toFixed(2)
            form.reset()
            this.dialog = false
          } finally {
            this.loading = false
          }
          break

        default:
          break
      }
    },
  },
  watch: {
    async dialog(value: boolean) {
      if (
        value &&
        this.user.services.includes(Services.Topup) &&
        !this.agentData.uuid
      ) {
        const response = await getTopUpAgentById(this.user.uuid)
        this.agentData = response.data
      }
    },
  },
})
